import {Injectable} from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class HeaderService {

  get jsonContentHeader(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  get formContentHeader(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
  }

  getXAuthHeader(token: string): HttpHeaders {
    return new HttpHeaders({
      'x-auth-token': token
    });
  }

  getXAuthHeaderFromCookie(): HttpHeaders {
    return new HttpHeaders({
      'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
      'Authorization': 'Bearer ' + sessionStorage.getItem('accessToken'),
      'Registration' : sessionStorage.getItem('registration')});
  }

  getXAuthHeaderFromCookieNoType(): HttpHeaders {
    return new HttpHeaders({
      'Authorization': 'Bearer ' + sessionStorage.getItem('accessToken'),
      'Registration' : sessionStorage.getItem('registration')});
  }

  getHttpOptionsXAuthHeaderFromCookie() {
    return { headers: this.getXAuthHeaderFromCookie() };
  }

  get httpOptionsJson() {
    return { headers: this.jsonContentHeader };
  }

  get httpOptionsFormContent() {
    return { headers: this.formContentHeader };
  }

  getHttpOptionsXAuthHeader(token: string) {
    return { headers: this.getXAuthHeader(token) };
  }
}
